import React from 'react';
import Hero from '../components/calendar/Hero'
import CalendariFrame from '../components/calendar/CalendariFrame';

export default function Calendar() {    

    return (
        <>
            <Hero />
            <CalendariFrame />
        </>
    );
}